<script>
  import Link from "../../shared/Link.svelte";
  import { _ } from "svelte-i18n";
</script>

<div class="title">
  <h2>{$_("lesson-U7uiF.h2-0")}</h2>
</div>
<hr />
<div class="text">
  <p>
    {$_("lesson-U7uiF.p-0")}
  </p>
  <p>
    {@html $_("lesson-U7uiF.p-1")}
  </p>
  <h3>{$_("lesson-U7uiF.h3-0")}</h3>
  <p>
    {$_("lesson-U7uiF.p-2-0")} <Link target="https://www.dwavesys.com/">D-Wave Systems Inc.</Link> {$_("lesson-U7uiF.p-2-1")} <Link target="https://www.fz-juelich.de/de/ias/jsc">Jülich Supercomputing Centre</Link>.
  </p>
  <p>
    {@html $_("lesson-U7uiF.p-3")}
  </p>
  <p>
    {@html $_("lesson-U7uiF.p-4")}
  </p>
</div>

<style>
  .title h2 {
    background: -webkit-linear-gradient(90deg, #1a91bc, #2eb6e8);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  hr {
    border: 1px solid white;
    border-top: 1px solid #ddd;
    margin: 20px auto;
  }
</style>